export const setQueryParams = (params) => {
    return async(dispatch) => {
        await dispatch({
            type: "SET_QUERY_PARAMS",
            payload: params,
        });
    }
} 